import * as Sentry from '@sentry/browser';
import icons from './modules/icons';
import animateIn from './modules/animate-in';

console.log(process.env.SENTRY_DSN);
console.log(process.env.SENTRY_ENVIRONMENT);
console.log(process.env.SENTRY_RELEASE);
try {
  if (process.env.SENTRY_DSN) {
    Sentry.init(
      {
        dsn: process.env.SENTRY_DSN,
        environment: process.env.SENTRY_ENVIRONMENT,
        release: process.env.SENTRY_RELEASE,
      },
    );
  } else {
    // eslint-disable-next-line no-console
    console.log('Sentry DSN not set');
  }
} catch (e) {
    // if for some reason the sentry info is wrong we don't want to kill the entire bundle
   // eslint-disable-next-line no-console
  console.error(e);
}

// Calling functions on initial page load

icons();
animateIn();



// WEBPACK FOOTER //
// ./library/js/main.js